// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import { ControlMessage, ControlMessageT } from "../control/control-message";
import {
  ControllerInfoMessage,
  ControllerInfoMessageT,
} from "../controller-info/controller-info-message";
import { FaultMessage, FaultMessageT } from "../fault/fault-message";
import { GroupControlMessage, GroupControlMessageT } from "../group-control/group-control-message";
import {
  GroupSupervisoryStatusMessage,
  GroupSupervisoryStatusMessageT,
} from "../group-supervisory-status/group-supervisory-status-message";
import { ServiceMessage, ServiceMessageT } from "../service/service-message";
import { StatusMessage, StatusMessageT } from "../status/status-message";
import { TrafficMessage, TrafficMessageT } from "../traffic/traffic-message";
import { UsageMessage, UsageMessageT } from "../usage/usage-message";

export enum MessageContent {
  NONE = 0,
  Status_StatusMessage = 1,
  Traffic_TrafficMessage = 2,
  Usage_UsageMessage = 3,
  Service_ServiceMessage = 4,
  Control_ControlMessage = 5,
  Fault_FaultMessage = 6,
  GroupSupervisoryStatus_GroupSupervisoryStatusMessage = 7,
  GroupControl_GroupControlMessage = 8,
  ControllerInfo_ControllerInfoMessage = 9,
}

export function unionToMessageContent(
  type: MessageContent,
  accessor: (
    obj:
      | ControlMessage
      | ControllerInfoMessage
      | FaultMessage
      | GroupControlMessage
      | GroupSupervisoryStatusMessage
      | ServiceMessage
      | StatusMessage
      | TrafficMessage
      | UsageMessage,
  ) =>
    | ControlMessage
    | ControllerInfoMessage
    | FaultMessage
    | GroupControlMessage
    | GroupSupervisoryStatusMessage
    | ServiceMessage
    | StatusMessage
    | TrafficMessage
    | UsageMessage
    | null,
):
  | ControlMessage
  | ControllerInfoMessage
  | FaultMessage
  | GroupControlMessage
  | GroupSupervisoryStatusMessage
  | ServiceMessage
  | StatusMessage
  | TrafficMessage
  | UsageMessage
  | null {
  switch (MessageContent[type]) {
    case "NONE":
      return null;
    case "Status_StatusMessage":
      return accessor(new StatusMessage())! as StatusMessage;
    case "Traffic_TrafficMessage":
      return accessor(new TrafficMessage())! as TrafficMessage;
    case "Usage_UsageMessage":
      return accessor(new UsageMessage())! as UsageMessage;
    case "Service_ServiceMessage":
      return accessor(new ServiceMessage())! as ServiceMessage;
    case "Control_ControlMessage":
      return accessor(new ControlMessage())! as ControlMessage;
    case "Fault_FaultMessage":
      return accessor(new FaultMessage())! as FaultMessage;
    case "GroupSupervisoryStatus_GroupSupervisoryStatusMessage":
      return accessor(new GroupSupervisoryStatusMessage())! as GroupSupervisoryStatusMessage;
    case "GroupControl_GroupControlMessage":
      return accessor(new GroupControlMessage())! as GroupControlMessage;
    case "ControllerInfo_ControllerInfoMessage":
      return accessor(new ControllerInfoMessage())! as ControllerInfoMessage;
    default:
      return null;
  }
}

export function unionListToMessageContent(
  type: MessageContent,
  accessor: (
    index: number,
    obj:
      | ControlMessage
      | ControllerInfoMessage
      | FaultMessage
      | GroupControlMessage
      | GroupSupervisoryStatusMessage
      | ServiceMessage
      | StatusMessage
      | TrafficMessage
      | UsageMessage,
  ) =>
    | ControlMessage
    | ControllerInfoMessage
    | FaultMessage
    | GroupControlMessage
    | GroupSupervisoryStatusMessage
    | ServiceMessage
    | StatusMessage
    | TrafficMessage
    | UsageMessage
    | null,
  index: number,
):
  | ControlMessage
  | ControllerInfoMessage
  | FaultMessage
  | GroupControlMessage
  | GroupSupervisoryStatusMessage
  | ServiceMessage
  | StatusMessage
  | TrafficMessage
  | UsageMessage
  | null {
  switch (MessageContent[type]) {
    case "NONE":
      return null;
    case "Status_StatusMessage":
      return accessor(index, new StatusMessage())! as StatusMessage;
    case "Traffic_TrafficMessage":
      return accessor(index, new TrafficMessage())! as TrafficMessage;
    case "Usage_UsageMessage":
      return accessor(index, new UsageMessage())! as UsageMessage;
    case "Service_ServiceMessage":
      return accessor(index, new ServiceMessage())! as ServiceMessage;
    case "Control_ControlMessage":
      return accessor(index, new ControlMessage())! as ControlMessage;
    case "Fault_FaultMessage":
      return accessor(index, new FaultMessage())! as FaultMessage;
    case "GroupSupervisoryStatus_GroupSupervisoryStatusMessage":
      return accessor(index, new GroupSupervisoryStatusMessage())! as GroupSupervisoryStatusMessage;
    case "GroupControl_GroupControlMessage":
      return accessor(index, new GroupControlMessage())! as GroupControlMessage;
    case "ControllerInfo_ControllerInfoMessage":
      return accessor(index, new ControllerInfoMessage())! as ControllerInfoMessage;
    default:
      return null;
  }
}

export type MessageContentT =
  | { type: "NONE"; value: null }
  | { type: "Status_StatusMessage"; value: StatusMessageT }
  | { type: "Traffic_TrafficMessage"; value: TrafficMessageT }
  | { type: "Usage_UsageMessage"; value: UsageMessageT }
  | { type: "Service_ServiceMessage"; value: ServiceMessageT }
  | { type: "Control_ControlMessage"; value: ControlMessageT }
  | { type: "Fault_FaultMessage"; value: FaultMessageT }
  | {
      type: "GroupSupervisoryStatus_GroupSupervisoryStatusMessage";
      value: GroupSupervisoryStatusMessageT;
    }
  | { type: "GroupControl_GroupControlMessage"; value: GroupControlMessageT }
  | { type: "ControllerInfo_ControllerInfoMessage"; value: ControllerInfoMessageT };
